import { IconButton, styled } from '@mui/material'

export const TransparentButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: 'transparent',
  color: theme.palette.primary.main,
  '&:hover': {
    backgroundColor: theme.palette.action.hoverOpacity,
    color: theme.palette.primary.main,
  },
}))
